const getLocalizedHomeUrl = (locale: string = document.documentElement.lang): string =>
  `/${locale ? `${locale}/` : ""}`

export default getLocalizedHomeUrl
